window.Search = (function () {

    var self;
    const selectors = {
        input: '#search-input',
        eventsItem: '[search-event]',
        resultsContainer: '#search-results',
        resultsItemsContainer: '#search-results-items',
        resultsItemsWrapper: '#search-results__items-wrapper',
        resultsScrollarea: '.awesome-scrollbar__area-wrapper.m-search .awesome-scrollbar__content-wrapper',
        resultsCountNode: '#search-results-count',
        closeButton: '#search__close',
        submitButton: '#search__submit'
    };

    const _timeSpan = 500;
    var searchTimeout,
        selectedResultIndex = -1;
    var currentSearchMode;
    var currentSearchParams;

    var highlightFounded = function (query, str) {
        var regex = new RegExp('(' + query + ')', 'gi');
        var highlightedString = str.replace(regex, '<span class="highlight">$1</span>');
        return highlightedString !== '' ? highlightedString : str;
    };

    var addSearchParamToUrl = function (baseUrl) {
        if (!baseUrl) return baseUrl;
        const searchParams = new URLSearchParams(window.location.search).toString();
        if (!searchParams) return baseUrl;
        const separator = baseUrl.includes('?') ? '&' : '?';
        return `${baseUrl}${separator}${searchParams}`;
    };

    const generateItemHtmlHandlers = {
        'default': {
            overflowResult: function() {
                return [
                    '<div class="search-results__item-empty">' + Localization.getString('Search.ManyEvents','Найдено слишком много событий. Пожалуйста, уточните запрос.') + '</div>'
                ].join('\n');
            },
            result: function(data, query) {
                var isfavClassname = data.isfav === true ? ' m-active' : ' ',
                    highlightedTitle = query ? highlightFounded(query, data.title) : data.title,
                    highlightedLeague = query ? highlightFounded(query, data.league) : data.league,
                    highlightetId = query ? highlightFounded(query, data.id.toString()) : data.id;

                const eventLink = addSearchParamToUrl(data.weblink);

                var html = [
            '<div class="search-results__item" search-event data-id="' + data.id + '" data-link="' + eventLink + '" data-mtm-trigger="search-item">',
                '<div class="search-results__item-icon">',
                    app.svgSports(data.sportid,'search__sport-icon'),
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Content/' + globalAppSettings.site + '/images/sprites/svg-icons-sports.svg#sport-' + data.sportid + '"></use>' +
                            '</svg>',
                '</div>',
                '<div class="search-results__item-title">',
                '<span class="highlight"></span>' + highlightedTitle + '<br />',
                    '<span class="search-results__item-group">' + highlightedLeague + (data.eventPositionText || "") + '</span>',
                        '</div>',
                ];
                if (currentSearchMode === 'results') {
                    html = html.concat([
                        '<div class="search-results__item-score m-main">' + data.score + '</div>',
                        '<div class="search-results__item-score">' + data.detailed + '</div>'
                    ]);
                }

                html = html.concat([
                    '<div class="search-results__item-number">' + highlightetId + '</div>',
                    '<div class="search-results__item-datetime">',
                        '<div class="search-results__item-date">' + data.date + '</div>',
                        '<div class="search-results__item-time">' + data.time + '</div>',
                    '</div>'
                ]);

                if (currentSearchMode === 'results') {
                    html = html.concat([
                        '<div class="search-results__item-fav"></div>'
                    ]);
                } else {
                    if(data.isNested && window.globalAppSettings.site === "cps") {
                        html = html.concat([
                            '<div class=" search-results__item-spacer"></div>',

                        ]);
                    } else {
                        html = html.concat([
                            '<div class="favorites-button search-results__item-fav' + isfavClassname + '" search-favstar data-mtm-trigger="search-fav">',
                        Utils.svgHtml('favorites', 'favorites-button__icon'),
                    '</div>'
                        ]);

                    }
                }
                html = html.concat(['</div>']);
                return html.join('\n');
            }
        },
        'addresses': {
            overflowResult: function() {
                return [
                    '<div class="search-results__item-empty">' + Localization.getString('Search.ManyAddresses','Найдено слишком много адресов. Пожалуйста, уточните запрос.') + '</div>'
                ].join('\n');
            },
            result: function(data, query) {
                var highlightFounded = function(query, str) {
                    var splits = query.split(' ');
                    var highlightedString = str;
                    for (var i = 0; i < splits.length; i++) {
                        var regex = new RegExp('(' + splits[i] + ')', 'gi');

                        highlightedString = highlightedString.replace(regex, '<span class="highlight">$1</span>');
                    }
                    return highlightedString !== '' ? highlightedString : str;
                };

                var highlightedTitle = query ? highlightFounded(query, data.city) : data.city,
                    highlightedLeague = query ? highlightFounded(query, data.address) : data.address;

                var html = [
                    '<div class="search-results__item" search-event data-id="' + data.id + '" style="display:flex; padding: 10px;" data-mtm-trigger="search-item">',
                    '<div class="search-results__item-title">', // style="flex: 2"
                            '<span class="highlight"></span>' + highlightedTitle + '<br />',
                            '<span class="search-results__item-group">' + highlightedLeague + '</span>',
                        '</div>',
                        '<div class="search-results__item-datetime">', // style="flex: 1"
                            '<div class="search-results__item-date">' + data.time + '</div>',
                        '</div>',
                        '<div class="favorites-button search-results__item-fav " search-favstar="" data-mtm-trigger="search-fav"></div>',
                    '</div>'
                ];
                return html.join('\n');
            }
        }
    }

    const generateEmptyHtmlHandlers = {
        'default': function() {
            return [
                '<div class="search-results__item-empty">' + Localization.getString('Search.NoResults','Ничего не найдено. Пожалуйста, уточните запрос.') + '</div>'
            ].join('\n');
        }
    };

    const searchHandlers = {
        'live': function (query) {
            if (query.length < 1) //TODO: redundant?
                return;

            Ajax.postJson("/Live/Search", {
                data: { query: query },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    self.drawResultEvents(resp, query);
                    self.show();
                }
            });
            return;
        },
        'liveSingleSport': function (query) {
            if (query.length < 1) //TODO: redundant?
                return;

            Ajax.postJson("/Live/Search", {
                data: { query: query, sportType: currentSearchParams.sportType },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    self.drawResultEvents(resp, query);
                    self.show();
                }
            });
            return;
        },
        'prematch': function (query) {
            if (query.length < 1)
                return;

            Ajax.postJson("/Prematch/Search", {
                data: { string: query }, //sportId: 87
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    self.drawResultEvents(resp, query);
                    self.show();
                }
            });
            return;
        },
        'results': function (query) {
            if (query.length < 1)
                return;

            var e = $.Event("keypress");
            e.which = 13;
            e.successHandler = function(resp, query) {
                self.drawResultEvents(resp, query);
                self.show();
            }
            $(selectors.input).trigger(e);
            return;
        },
        'prematchSingleSport': function (query) {
            if (query.length < 1) //TODO: redundant?
                return;

            Ajax.postJson("/Prematch/Search", {
                data: { string: query, sportType: currentSearchParams.sportType },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    self.drawResultEvents(resp, query);
                    self.show();
                }
            });
            return;
        },
        'favLive': function (query) {
            if (query.length < 1) //TODO: redundant?
                return;

            Ajax.postJson("/Live/Search", {
                data: { query: query },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    self.drawResultEvents(resp, query);
                    self.show();
                }
            });
            return;
            //if (query.length < 1)
            //    return;

            ////ClientSearch.Search
        },
        'addresses': function (query) {
            if (query.length < 1) //TODO: redundant?
                return;

            Addresses.search(query);
            return;
        }
    };

    const hideCloseButtonsHandlers = {
        'results': function() {
            var e = $.Event('keypress');
            e.which = 13;
            $(selectors.input).trigger(e);
        },
        'addresses': function (searchNode) {
            Addresses.reset();
        }
    };

    const clickOnEventHandlers = { //распихать по разным модулям поиска или скоупам, добавить default
        'default': function (clickNode) {
            var link = $(clickNode).data('link');
            if (link) {
                SPA.navigate(link);
                self.hide();
            }
            else {
                var id = $(clickNode).data('id');
                if (id) {
                    SPA.navigate('/event/' + id + window.location.search);
                    self.hide();
                }
            }
            return;
        },
        'prematch': function (clickNode) {
            return clickOnEventHandlers['default'](clickNode);
        },
        'prematchSingleSport': function (clickNode) {
            return clickOnEventHandlers['default'](clickNode);
        },
        'live': function (clickNode) {
            return clickOnEventHandlers['default'](clickNode);
        },
        'liveSingleSport': function (clickNode) {
            return clickOnEventHandlers['default'](clickNode);
        },
        'favLive': function (clickNode) {
            return clickOnEventHandlers['default'](clickNode);
        },
        'results': function (clickNode) {
            var id = $(clickNode).data('id');

            BinderResults.scrollToEvent(id);

            self.hide();
            return;
        },
        'addresses': function (clickNode) {
            var id = $(clickNode).data('id');

            Addresses.select(id);

            self.hide();
            return;
        }
    };

    const focusSearchInputHandlers = {
        'default': function () {
            if (currentSearchMode === 'favLive' && $(this).val().length < 2) {

            }
        },
        'live': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('liveHand');
            return false;
        },
        'liveSingleSport': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('liveHandSingle');
            return false;
        },
        'prematch': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('prematchHand');
            return false;
        },
        'results': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('resultsHand');
            return false;
        },
        'prematchSingleSport': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('prematchHandSingle');
            return false;
        },
        'favLive': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('favliveHand');
            return false;
            //if (ClientSearch.isInitiated())
            //self.show();
            //return false;
        },
        'addresses': function (searchNode) {
            if ($(searchNode).val() !== '')
                self.show();

            app.console.log('addressesHand');
            return false;
        }
    };

    function selectNextResult() {
        var newIndex = selectedResultIndex + 1;

        if (newIndex > $(selectors.eventsItem).length - 1)
            newIndex = 0;

        selectResult(newIndex);
    }

    function selectPrevResult() {
        var newIndex = selectedResultIndex - 1;

        if (newIndex < 0)
            newIndex = $(selectors.eventsItem).length - 1;

        selectResult(newIndex);
    }

    function selectResult(i) {
        var events = $(selectors.eventsItem);

        events.removeClass('m-selected');
        events.eq(i).addClass('m-selected');

        selectedResultIndex = i;

        scrollToSelected();
    }

    function scrollToSelected() {
        var scrollarea = $(selectors.resultsScrollarea),
            scrollareaHeight = scrollarea.height(),
            currentScrollTop = scrollarea.scrollTop(),
            selectedRowPositionTop = $(selectors.eventsItem).eq(selectedResultIndex).position().top;

        if (scrollareaHeight <= selectedRowPositionTop - currentScrollTop || selectedRowPositionTop - currentScrollTop < 0) {
            scrollarea.scrollTop(selectedRowPositionTop);
        }
    }


    return {
        init: function (searchMode, searchParams) {
            this.scrollbar = new AwesomeScrollbar(selectors.resultsItemsContainer, 'm-search');
            this.setCurrentSearchMode(searchMode);
            this.setSearchParams(searchParams);
            this.unbindUI();
            this.bindUI();
        },
        setCurrentSearchMode: function (mode) {
            if (!mode) {
                mode = 'default';
            }
            currentSearchMode = mode;
        },
        setSearchParams: function (params) {
            params = params || {};
            currentSearchParams = params;
        },
        bindUI: function () {
            self = this;
            var body = app.body;

            body.on('focus', selectors.input, function () {
                focusSearchInputHandlers[currentSearchMode](this);
            });

            body.on('click', selectors.resultsContainer, function (e) {
                return;
            });

            body.on('click', selectors.eventsItem, function (e) {
                if(e.target.closest('.favorites-button')) {
                    return;
                }
                clickOnEventHandlers[currentSearchMode](this);
            });

            body.on('mouseenter', selectors.eventsItem, function () {
                selectResult($(this).index());
            });

            this.bindCloseButtonHandler();

            body.on('keyup', selectors.input, function (e) {
                var val = $(this).val().trim();

                if ($.inArray(e.which, [13, 38, 40, 27]) === -1) {
                    clearTimeout(searchTimeout);

                    if (val.length === 0) {
                        self.hideCloseButton();
                    } else if (val.length < 2) {
                        self.hide();
                    } else {
                        searchTimeout = setTimeout(searchHandlers[currentSearchMode], _timeSpan, val);
                    }
                }

                return;
            });
        },
        unbindUI: function () {
            $('body').off('click', selectors.resultsContainer)
                .off('focus', selectors.input)
                .off('click', selectors.eventsItem)
                .off('mouseenter', selectors.eventsItem)
                .off('keyup', selectors.input);

            this.unbindCloseButtonHandler();
        },
        show: function () {
            var self = this;

            selectedResultIndex = null;

            $(selectors.resultsContainer).addClass('m-visible');

            $(document).on('click.searchResults', function (e) {
                if (e.target !== $(selectors.input).get(0))
                    self.hide();
            });

            $('body').on('keyup.searchResults', function (e) {
                // arrow down
                if (e.key === "ArrowDown") {
                    selectNextResult();
                }
                // arrow up
                else if (e.key === "ArrowUp") {
                    selectPrevResult();
                }
                // enter
                    else if (e.key === "Enter") {
                    if (selectedResultIndex === null) {
                        $(selectors.eventsItem).length === 1 ? clickOnEventHandlers[currentSearchMode]($(selectors.eventsItem).first()) : clickOnEventHandlers[currentSearchMode]();
                    } else {
                        $(selectors.eventsItem).eq(selectedResultIndex).click()
                    }
                }
                // escape
                else if (e.key === "Escape") {
                    self.hide();
                }

                e.stopImmediatePropagation();
                return false;
            });
        },
        hide: function () {
            $(selectors.resultsContainer).removeClass('m-visible');
            $(document).off('click.searchResults');
            $('body').off('keyup.searchResults');
        },
        drawResultEvents: function (response, query) {

            var html = '',
                events = response.events,
                isOverflow = response.overflow,
                eventsCnt = events.length;
            query = query || null;

            if (eventsCnt > 0) {
                var generateHandlers = (generateItemHtmlHandlers[currentSearchMode] || generateItemHtmlHandlers['default']);

                for (var i = 0; i < eventsCnt; i++) {
                    html += generateHandlers.result(events[i], query);
                }
                if (isOverflow) {
                    html += generateHandlers.overflowResult();
                }
            } else {
                html += (generateEmptyHtmlHandlers[currentSearchMode] || generateEmptyHtmlHandlers['default'])();
            }


            $(selectors.resultsCountNode).text(eventsCnt);
            $(selectors.resultsItemsContainer).html(html);

            if (eventsCnt > 7) {
                $(selectors.resultsItemsWrapper).addClass('m-with-scroll');
            } else {
                $(selectors.resultsItemsWrapper).removeClass('m-with-scroll');
            }
        },
        showCloseButton: function () {
            $(selectors.closeButton).show();
            $(selectors.submitButton).hide();
        },
        hideCloseButton: function () {
            $(selectors.closeButton).hide();
            $(selectors.submitButton).show();

            if (hideCloseButtonsHandlers[currentSearchMode])
                hideCloseButtonsHandlers[currentSearchMode](this);
        },
        bindCloseButtonHandler: function () {
            var self = this;

            $(selectors.input).on('keyup.closeButton', function () {
                if ($(this).val().length > 0) {
                    self.showCloseButton();
                } else {
                    self.hideCloseButton();
                }
            })

            $(document).on('click', selectors.closeButton, function (e) {
                self.clear();
                $(selectors.input).trigger('keyup');
            });
        },
        unbindCloseButtonHandler: function () {
            $(selectors.input).off('keyup.closeButton');

            $(document).off('click', selectors.closeButton);
        },
        clear: function () {
            var self = this;
            $(selectors.input).val('');
            self.hide();
            self.hideCloseButton();
        },
        focusOnInput: function () {
            $(selectors.input).focus();
        }
    }
}());

//$(function () {
//    window.Search.init();
//});